import $axios from "../../api";
import FileSaver from "file-saver";
const state = {
  isLoading: false,
  createLoading: false,
  errors: "",
  isSuccess: false,
  levelList: [],
  logLevel: [],
  levelData: {},
  page: 1,
  // # Assessment ,
  assessmentList: [],
  assessmentPoint: [],
};

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_ASSESSMENT_LIST(state, payload) {
    state.assessmentList = payload;
  },
  SET_ASSESSMENT_POINT(state, payload) {
    state.assessmentPoint = payload;
  }
};

const actions = {
  Assessment({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);

    // Build query string from payload
    const params = new URLSearchParams();
    if (payload.year) params.append('year', payload.year);
    if (payload.name) params.append('name', payload.name);
    if (payload.nik) params.append('nik', payload.nik);
    if (payload.department) params.append('department', payload.department);
    if (payload.division) params.append('division', payload.division);
    if (payload.level) params.append('level', payload.level);
    if (payload.status !== '' && payload.status !== null && payload.status !== undefined) params.append('status', payload.status);
    if (payload.page) params.append('page', payload.page);
    if (payload.sortby) params.append('sortby', payload.sortby);
    if (payload.sortdesc) params.append('sortdesc', payload.sortdesc);

    let url = `/hr/assessment/list?${params.toString()}`;

    return new Promise((resolve, reject) => {
      $axios
        .get(url)
        .then((response) => {
          commit("SET_ASSESSMENT_LIST", response.data);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch('Main/globalSweetAlert', error.response, { root: true });
          reject(error);
        });
    });
  },
  viewAssessment({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    let url = `/hr/assessment/view?nik=${payload.nik}&year=${payload.year}`;
    return new Promise((resolve, reject) => {
      $axios
        .get(url)
        .then((response) => {
          commit("SET_ASSESSMENT_POINT", response.data);
          // alert('response.data: ' + JSON.stringify(response.data));
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch('Main/globalSweetAlert', error.response, { root: true });
          reject(error);
        });
    });
  },
  delete({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    let url = `/hr/assessment/showhide`;
    let payloadData = {
      year: payload.year,
    };
    return new Promise((resolve, reject) => {
      $axios
        .post(url, payloadData)
        .then((response) => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch('Main/globalSweetAlert', error.response, { root: true });
          reject(error);
        });
    });
  },
  exportExcel({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    let url = `hr/assessment/export-excel`;
    try {
      $axios.get(url, {
        params: payload,
        responseType: 'blob'
      }).then((response) => {
        let fileName = 'assessment_' + new Date().toISOString().split('T')[0] + '.xlsx';
        const contentDisposition = response.headers['content-disposition']
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = fileNameMatch[1].replace(/['"]/g, '');
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        commit("SET_LOADING", false);
      }).catch((error) => {
        dispatch("Main/globalSweetAlert", error.response, { root: true });
        commit("SET_LOADING", false);
      });
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
      commit("SET_LOADING", false);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
